<template>
	<div class="mb-4">
		<UserManage></UserManage>
	</div>
</template>

<script>
import UserManage from '@/components/Widgets/UserManage/UserManage.vue';
export default {
  name: 'Users',
  components: {
    UserManage,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>